const LINKEDIN_HOSTS = new Set([
  'linkedin.com',
  'www.linkedin.com',
]);

const getUrl = (value) => {
  const input = typeof value === 'string' ? value : value?.url;
  if (!input || typeof input !== 'string') return null;

  try {
    const url = new URL(input.trim());
    if (url.protocol !== 'https:' || !LINKEDIN_HOSTS.has(url.hostname)) {
      return null;
    }
    return url;
  } catch {
    return null;
  }
};

export const getLinkedInEmbedUrl = (value) => {
  const url = getUrl(value);
  if (!url) return null;

  if (url.pathname.startsWith('/embed/feed/update/')) {
    return url.toString();
  }

  const urnMatch = url.pathname.match(/(urn:li:(?:ugcPost|share):[A-Za-z0-9-]+)/);
  if (!urnMatch) return null;

  return `https://www.linkedin.com/embed/feed/update/${urnMatch[1]}`;
};

export const getLinkedInEmbedKind = (value) => {
  const url = getUrl(value);
  if (!url || !getLinkedInEmbedUrl(value)) return null;

  return value?.kind === 'video' ? 'video' : 'post';
};

export const getLinkedInEmbedData = (value) => {
  const embedUrl = getLinkedInEmbedUrl(value);
  if (!embedUrl) return null;

  return {
    embedUrl,
    kind: getLinkedInEmbedKind(value),
  };
};
